import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Form, Message } from 'element-ui'
import { Route, RouteConfig } from 'vue-router'
import router from '@/router'
import { PermissionModule } from '@/store/modules/permission'
import { RoleData } from '@/utils/config'
import { getUserId, getUserInfo } from '@/utils/storage'
import {
  getMenuPermission
} from '@/api/user';
import store from './store'
import {
  UserModule
} from "@/store/modules/user"
import {
  mallInfo,
} from '@/api/user'

NProgress.configure({ showSpinner: false })

const findRouterName: any = (router: RouteConfig) => {
  if (router.children && router.children.length) {
    return findRouterName(router.children[0])
  } else {
    return router.name
  }
}

async function getmallInfo(){
  try{
    const res = await mallInfo({})
    if(res.IsSuccess){
      store.dispatch('setmallInfo', res.Result)
    }
  }finally{
    //
  }
}

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach(async (to: Route, _: Route, next: any) => {
  NProgress.start();
  //在一些页面每次进去需要弹窗 但是页面有缓存 所以需要一些判断清除缓存
  store.dispatch('setEarlywarningShow', true)
  if (getUserInfo() && getUserId()) {
    if (to.path === '/login') {
      next({
        path: '/'
      })
      NProgress.done();
    }else if(to.path === '/goJianXi/goJianXi'){
      // window.open('http://test2backend.routuan.com/#/home/index')
      // console.log(location.origin,'http://testbackend.routuan.com')
      window.open(location.origin+`/jianxi/#/home/index?USER_ID_KEY=${JSON.stringify(getUserId())}&USER_INFO_KEY=${JSON.stringify(getUserInfo())}`)
      next(_.path)
      NProgress.done();
    }else {
      if (!PermissionModule.dynamicRoutes.length) {
        try { 
          const role: any = await getMenuPermission({});
          PermissionModule.setRoutes(role.Result);
          router.addRoutes(PermissionModule.dynamicRoutes);
          if (to.path === '/home') {
            next({
              name: findRouterName(PermissionModule.dynamicRoutes),
              replace: true
            })
          } else {
            next({
              ...to,
              replace: true,
            })
          }
          NProgress.done();
        } catch (err) {
          next('/login')
          NProgress.done()
        }
      } else {
        await getmallInfo()
        // console.log(_.path)
        if(to.path === '/product/list'&&(_.path==='/product/product-detail'||_.path==='/product/activity-detail')){
          store.dispatch('setEarlywarningShow', false)
        }
        next()
        NProgress.done();
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
      NProgress.done()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})